<div class="dataset-field">
  <div>
    <label [class.is-required]="required">{{ title }}</label>
    <div class="app-ace-container" [ngStyle]="{ height: multiLine ? '110px' : '24px' }">
      <div #editor></div>
    </div>
  </div>
  @if (instructions && !hideDatasetSelection) {
    <div class="instructions">
      {{ instructions }}
    </div>
  }
  @if (!hideDatasetSelection) {
    <div>
      <div class="select is-primary is-fullwidth is-medium">
        <select
          [(ngModel)]="selectedDatasetUId"
          (change)="datasetChanged()">
          @for (dataset of datasets; track dataset.uId) {
            <option
              [ngValue]="dataset.uId">
              {{ dataset.name }}
            </option>
          }
        </select>
      </div>
    </div>
  }
</div>
